<template>
	<div class="open-account-userinfo">

		<h1 class="h1_title">财务状况与投资目标</h1>

		<van-form @submit="nextStep()">
			<van-field
				readonly
				clickable
				label="年收入"
				label-width="80px"
				:value="formItem.annual_income"
				placeholder="请选择"
				@click="show1 = true"
				required
				:rules="rules.annual_income"
			/>
			<van-popup v-model="show1" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr1"
					value-key="name"
					@cancel="show1 = false"
					@confirm="onConfirm1"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="资产净值"
				label-width="80px"
				:value="formItem.net_asset_value"
				placeholder="请选择"
				@click="show2 = true"
				required
				:rules="rules.net_asset_value"
			/>
			<van-popup v-model="show2" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr2"
					value-key="name"
					@cancel="show2 = false"
					@confirm="onConfirm2"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="住宅业权"
				label-width="80px"
				:value="formItem.residential_property_rights"
				placeholder="请选择"
				@click="show3 = true"
				required
				:rules="rules.residential_property_rights"
			/>
			<van-popup v-model="show3" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr3"
					value-key="name"
					@cancel="show3 = false"
					@confirm="onConfirm3"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="财产来源"
				label-width="80px"
				:value="formItem.source_of_property"
				placeholder="请选择"
				@click="show4 = true"
				required
				:rules="rules.source_of_property"
			/>
			<van-popup v-model="show4" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr4"
					value-key="name"
					@cancel="show4 = false"
					@confirm="onConfirm4"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="投资目的"
				label-width="80px"
				:value="formItem.investment_purpose"
				placeholder="请选择"
				@click="show5 = true"
				required
				:rules="rules.investment_purpose"
			/>
			<van-popup v-model="show5" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr5"
					value-key="name"
					@cancel="show5 = false"
					@confirm="onConfirm5"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="预计投资时间"
				label-width="80px"
				:value="formItem.expected_investment_time"
				placeholder="请选择"
				@click="show6 = true"
				required
				:rules="rules.expected_investment_time"
			/>
			<van-popup v-model="show6" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr6"
					value-key="name"
					@cancel="show6 = false"
					@confirm="onConfirm6"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="预计投资金额"
				label-width="80px"
				:value="formItem.expected_investment_money"
				placeholder="请选择"
				@click="show7 = true"
				required
				:rules="rules.expected_investment_money"
			/>
			<van-popup v-model="show7" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr7"
					value-key="name"
					@cancel="show7 = false"
					@confirm="onConfirm7"
				/>
			</van-popup>

			<div class="common_block">
				<van-button type="warning" block round native-type="submit">{{translate('userinfo_next_step')}}</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
	export default {
		name: 'account_finance',
		data() {
			return {
				token: "",
				
				formItem: {
					annual_income: "",
					net_asset_value: "",
					residential_property_rights: "",
					source_of_property: "",
					investment_purpose: "",
					expected_investment_time: "",
					expected_investment_money: "",
				},
				rules: {
					annual_income: [
						{
							required: true,
							message: '请选择年收入',
							trigger: 'onBlur'
						}						
					],
					net_asset_value: [
						{
							required: true,
							message: '请选择资产净值',
							trigger: 'onBlur'
						}						
					],
					residential_property_rights: [
						{
							required: true,
							message: '请选择住宅业权',
							trigger: 'onBlur'
						}						
					],
					source_of_property: [
						{
							required: true,
							message: '请选择财产来源',
							trigger: 'onBlur'
						}						
					],
					investment_purpose: [
						{
							required: true,
							message: '请选择投资目的',
							trigger: 'onBlur'
						}						
					],
					expected_investment_time: [
						{
							required: true,
							message: '请选择预计投资时间',
							trigger: 'onBlur'
						}						
					],
					expected_investment_money: [
						{
							required: true,
							message: '请选择预计投资金额',
							trigger: 'onBlur'
						}						
					]
				},
				show1: false,
				arr1: [{name:''}],
				show2: false,
				arr2: [{name:''}],
				show3: false,
				arr3: [{name:''}],
				show4: false,
				arr4: [{name:''}],
				show5: false,
				arr5: [{name:''}],
				show6: false,
				arr6: [{name:''}],
				show7: false,
				arr7: [{name:''}],
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				this.init()
				this.getquestion(3)
			}
		},
		methods: {
			init(){
				//根据TOKEN获取信息
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							var data = res.data.financial_situation_data		
							if (data.length != 0) {
								this.formItem.annual_income=data.annual_income
								this.formItem.net_asset_value=data.net_asset_value
								this.formItem.residential_property_rights=data.residential_property_rights
								this.formItem.source_of_property=data.source_of_property
								this.formItem.investment_purpose=data.investment_purpose
								this.formItem.expected_investment_time=data.expected_investment_time
								this.formItem.expected_investment_money=data.expected_investment_money
							}
						}
					} else {
						this.$toast.fail(res.error_text)
					}
				})
			},
			getquestion(type) {
				this.$axios({
					method: 'post',
					url: 'account_open/getquestion',
					data: {
						filter_type:type
					}
				}).then ((res) => {
					if (res.success) {
						this.arr1=res.data[0].answers
						this.arr2=res.data[1].answers
						this.arr3=res.data[2].answers
						this.arr4=res.data[3].answers
						this.arr5=res.data[4].answers
						this.arr6=res.data[5].answers
						this.arr7=res.data[6].answers
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			
			onConfirm1(value) {
				if (value) {
					this.formItem.annual_income = value.name
				}
				this.show1 = false
			},
			onConfirm2(value) {
				if (value) {
					this.formItem.net_asset_value = value.name
				}
				this.show2 = false
			},
			onConfirm3(value) {
				if (value) {
					this.formItem.residential_property_rights = value.name
				}
				this.show3 = false
			},
			onConfirm4(value) {
				if (value) {
					this.formItem.source_of_property = value.name
				}
				this.show4 = false
			},
			onConfirm5(value) {
				if (value) {
					this.formItem.investment_purpose = value.name
				}
				this.show5 = false
			},
			onConfirm6(value) {
				if (value) {
					this.formItem.expected_investment_time = value.name
				}
				this.show6 = false
			},
			onConfirm7(value) {
				if (value) {
					this.formItem.expected_investment_money = value.name
				}
				this.show7 = false
			},
			nextStep() {
				this.$axios({
					method: 'post',
					url: 'account_open/alter',
					data: {
						token: this.token,
						financial_situation_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						this.$router.push('/account/invest?token=' + this.token)
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			}
		},
	}
</script>